<template>
	<div class="sharepage">
		<top-header></top-header>
		<!-- <div class="breadcrumb-section mb-md-5 py-md-3 py-sm-2">
			<b-container>
				<b-row>
					<b-col class="text-left">
						<h5 class="my-md-3 font-xl">SHARE {{$session.get('share_user_id')}}</h5>		
					</b-col>
					<b-col class="text-right">
						<h6 class="my-md-3 font-xl">HOME / SHARE </h6>		
					</b-col>
				</b-row>
			</b-container>
		</div> -->
		<b-container class="mb-md-5 py-md-3 py-sm-2" v-if="activ_link==1">
				<div class="all-products--wrapper d-flex flex-wrap justify-content-between" v-if="share_data.length>0" >
				  <div v-for="product in share_data" :key="product.id"
					class="product--wrapper d-flex flex-column align-items-center">
					
					<!--<span class="product-title d-block"><a :href="'/product/'+product.product_id">{{product.title}}</a></span> -->
					<!--<product-offer :offer="true" :product="product"></product-offer>-->
					
					<div class="product--img-wrapper imgcatOrg">
					<a v-if="product.product_slug==null" :href="'/product/'+product.product_id">
					  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
						:src="$root.MEDIAAPI+'toolimage/get_image?size=253x280&src='+product.image"
						:alt="product.title"></b-img-lazy>
					  </a>
					  <a v-else :href="'/'+product.product_slug">
					  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
						:src="$root.MEDIAAPI+'toolimage/get_image?size=253x280&src='+product.image"
						:alt="product.title"></b-img-lazy>
					  </a>
					</div>
					
					<cateoryimage-slider v-if="product.product_slug==null"   :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/product/'+product.product_id" class="d-none d-md-block" ></cateoryimage-slider>
					<cateoryimage-slider v-else :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/'+product.product_slug" class="d-none d-md-block" ></cateoryimage-slider>
					
					
					<!--<product-offer-20 :offer="true" :product="product"></product-offer-20> -->
					
					
					<h4  class="text-truncate m-0 ali" style="text-align: center;"><b-link :href="'/brand/'+product.brand.replace(/ /g,'-')" >{{product.brand}} </b-link></h4>
				   <b-link v-if="product.product_slug==null" :href="'/product/'+product.product_id" class="product-title text-capitalize">{{product.title}}</b-link>
				   <b-link v-else :href="'/'+product.product_slug" class="product-title text-capitalize">{{product.title}}</b-link>
				   
					<product-price :shareitem="true" :product="product"></product-price>
					<product-rating :userrating="product.total_rating"></product-rating>
					<!--<addtocart-button :productData="product" :pagecategory="true"></addtocart-button> -->
					
					<!--<div v-if="product.dimension!=''" ><h6>Dimension: <span class="dimensionFont ">{{product.dimension}}</span></h6></div> -->
					
					<product-attribute v-if="product.product_type==2" :product="product" :productIncart="$root.cart.items"></product-attribute>
					<div class="mb-2" style="text-align: center;">
						<b-link class="btn-solid btn2" v-if="product.product_type==1"  @click="$root.updateCart(product,1,'','',$route.params.shareid,share_user_id); $bvModal.hide('qv-modal')">Buy Now</b-link>
					</div>
				  </div>
				  
				  <div v-if="share_data.length==3"  class=" d-flex flex-column align-items-center" style="width: 255px;">
					</div> 
					<div v-if="share_data.length==2"  class=" d-flex flex-column align-items-center" style="width: 255px;">
					</div>
					<div v-if="share_data.length==2"  class=" d-flex flex-column align-items-center" style="width: 255px;">
					</div>
				</div>
				
				<div class="all-products--wrapper d-flex flex-wrap justify-content-between" v-if="share_data.length==0">
				
				<div class="product--wrapperno d-flex flex-column align-items-center">
                <span class="product-title d-block">Share Products not found!</span>
				</div>
			  
			  
			  </div>

		</b-container>
		<b-container class="mb-md-5 py-md-3 py-sm-2" v-else>
			<div class="all-products--wrapper d-flex flex-wrap justify-content-between" >
				
				<div class="product--wrapperno d-flex flex-column align-items-center">
                <span class="product-title d-block">Share link has been expired!</span>
				</div>
			</div>
		</b-container>
		<b-container>
			<!-- <b-row class="product-info" v-if="share_data.length == 1">
				<b-col class="product-images">
                    <b-img :src="$root.MEDIAPATH+'products/'+share_data[0].image" fluid></b-img>
				</b-col>
                <b-col cols="6" md="7">
                    <div class="product-title">{{share_data[0].title}}</div>
                    <div class="product-desc">{{share_data[0].short_description}}</div>
                    <div class="product-price">{{$root.currency()+$root.tofixed(share_data[0].special_price * share_data_qty, 2)}} <small class="peritem" v-if="share_data_qty > 1">({{$root.currency()+$root.tofixed(share_data[0].special_price, 2)}} per item)</small></div>
                    <p class="my-1">M.R.P.:<del>{{$root.currency()+$root.tofixed(share_data[0].price, 2)}}</del></p>
					<p class="mt-1 mb-3">You Save: {{$root.currency()+$root.tofixed(share_data[0].price - share_data[0].special_price, 2)}} ({{$root.currency()+$root.tofixed((share_data[0].price - share_data[0].special_price)*100/share_data[0].price, 0)}}% off)</p>
					<b-row class="mb-3">
						<b-col cols="1" class="pt-1">Qty: </b-col>
						<b-col cols="3"><b-form-select v-model="share_data_qty" :options="qty_options"></b-form-select></b-col>
					</b-row>
                    <b-link class="btn2 btn-solid" @click="$root.updateCart(share_data[0], share_data_qty)">Add To Cart</b-link>
                </b-col>
			</b-row>
			<b-row v-else cols="4" class="item-list">
				<b-col v-for="item in share_data" :key="item.id" class="mb-3 px-2 item-cell">
					<div class="item-image text-center">
						<b-img :src="$root.MEDIAPATH+'products/'+item.image.replace('_rg','_th')" alt="Image" ></b-img>
					</div>
					<div v-if="item.special_price != ''">
						<b-link :href="'/product/'+item.product_id" class="item-title">{{item.title}}</b-link>
						<b>{{$root.currency()+$root.tofixed(item.special_price, 2)}}</b>   <small>M.R.P. <del>{{$root.currency()+$root.tofixed(item.price, 2)}} </del></small>
						<p class="font-md">You Save: {{$root.currency()+$root.tofixed(item.price - item.special_price, 2)}} ({{$root.currency()+$root.tofixed((item.price - item.special_price)*100/item.price, 0)}}% off)</p>
						<div class="item-cart-info flex-row justify-content-center px-4">
							<div class="icon-btn" @click="showQuickView(item)"><i class="fa fa-search font-xl" title="Quickview"></i></div>
							<div class="icon-btn" @click="$root.updateCart(item, 1)"><i class="fa fa-shopping-cart font-xl" title="Add To Cart"></i></div>
							<div class="icon-btn"><i class="fa fa-heart font-xl" title="Wishlist"></i></div>
						</div>
					</div>
				</b-col>
			</b-row>  -->
			<!--<product-swiper :products="related_products" :showQuickViewListener="showQuickView" heading="Related Products"></product-swiper> -->
			<!-- {{inCartItem}} -->
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		
		<!-- <quickview :modaldata="modal_data" :modaldataqty=1></quickview>-->
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
//import ProductSwiper from "@/components/product-swiper.vue";
//import Quickview from "@/components/quickview.vue";
import ProductRating from "@/components/product-rating.vue";
import ProductPrice from "@/components/product-price.vue";
//import ProductOffer from "@/components/product-offer.vue";
//import ProductOffer20 from "@/components/product-offer-20.vue";
//import AddtocartButton from "@/components/addtocartButton.vue";
import ProductAttribute from "@/components/product-attribute.vue";
import CateoryimageSlider from "@/components/cateoryimageSlider.vue";


import '../assets/category.scss';
export default {
	name: 'Dashboard',
	props: { 
		metadata: { type: Object },
	},
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		//"product-swiper": ProductSwiper,
		//"quickview": Quickview,
		"product-rating": ProductRating,
		"product-price": ProductPrice,
		//"product-offer": ProductOffer,
		//"product-offer-20": ProductOffer20,
		//"addtocart-button": AddtocartButton,
		"product-attribute": ProductAttribute,
		"cateoryimage-slider": CateoryimageSlider,
	},
	mounted(){
		this.initload();
		//console.log('Current Swiper instance object', this.mySwiper)
		//this.$refs.rpswiper.$swiper.slideTo(3, 1000, false);
	},
	data() {
		return{
			loading: true,
            share_info: {},
			share_data: [],
			share_data_qty: 1,
			modal_data: {
				price: 0,
				special_price: 0
			},
			url: this.$root.WEBURL+'getshare',
			empty_data: {
				price: 0,
				special_price: 0
			},
			qty_options: [
				{ value: 1, text: '1' },
				{ value: 2, text: '2' },
				{ value: 3, text: '3' },
				{ value: 4, text: '4' },
				{ value: 5, text: '5' },
				{ value: 6, text: '6' }
			],
			related_products: [],
			thumbnailProps: { blank: false, fluidGrow: true, width: 350, height: 350,class: 'm1' },
			filter:'',
			inCartItem:[],
			share_user_id:'',
			activ_link:1,
			phoneImageWidth:253,
			phoneImageHeight:280,
		};
	},
	methods: {
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                shareid: self.$route.params.shareid
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.share_info = response.data.result.share_record;
					//self.share_user = self.share_info.user_id;
					// registering userid in session
					self.$session.set('share_user_id', self.share_info.user_id);
					self.share_user_id= self.share_info.user_id;
					self.activ_link= self.share_info.activ_link;

					self.share_data = JSON.parse(self.share_info.share_data);
					self.related_products = response.data.result.related_products;
					
					//console.log('Current Swiper instance object', self.mySwiper);
					//self.mySwiper.update();
					//self.mySwiper.slideTo(2, 1000, false)
					
                    //console.log(self.share_data);
					self.loading = false;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			
			/* console.log("MyQl"+JSON.stringify(self.$session.get('cart').items));
			self.$root.cart.items.forEach((value, index) => {
				self.inCartItem.push(value.orgPId);
				console.log(value);
				console.log(index);
			});*/
			
		}
	},
	metaInfo() {
        //console.log('-------META INFO-------');
		return{
			title: this.metadata.title,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				/*{ name: 'keywords', content: this.metadata.keywords },*/
				{ name: 'description', content: this.metadata.description },
				{ property:'og:image', content: 'https://www.alluraa.com/media/images/logo.png', },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
				
			]
		}
	}
}
</script>
<style >
	.categorieslist .slick-dots{
		bottom: -15px;
		height: 29px;
	}
	@media only screen and (max-width:640px) {
		.sizeRow{
		padding-left: 7%;
		}
		.productSize{				
				width: 100% !important;
		}
		
	}

</style>
